export enum FilterType {
  TextField,
  Select,
  CheckboxGroup,
  DatePicker,
}
